import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const steps = [
  { num: '01', title: 'Sync', desc: 'Connect Rekordbox databases or scan folders, then keep your library state in one place.' },
  { num: '02', title: 'Build', desc: 'Use Quick Tag, Graph Playlist, Chapter Builder, and Analytics to prep better sets faster.' },
  { num: '03', title: 'Ship', desc: 'Export updates, benchmark performance, and let Watch Folder + downloader tools keep things moving.' },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="how-it-works" data-testid="how-it-works-section" ref={ref} style={{ padding: 'clamp(120px,14vw,200px) 0' }}>
      <div className="container">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.8 }}
          style={{ textAlign: 'center', maxWidth: 480, margin: '0 auto 80px' }}>
          <span style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 500, color: '#52525B', letterSpacing: '0.1em', textTransform: 'uppercase' }}>How It Works</span>
          <h2 data-testid="how-it-works-title" style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.03em', marginTop: 16 }}>
            From library mess to set-ready
          </h2>
        </motion.div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 48 }} className="steps-grid">
          {steps.map((s, i) => (
            <motion.div key={i} data-testid={`step-${i}`} initial={{ opacity: 0, y: 30 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.7, delay: 0.15 + i * 0.1 }}>
              <div style={{ fontFamily: 'var(--mono)', fontSize: 11, fontWeight: 500, color: '#3F3F46', letterSpacing: '0.08em', marginBottom: 16 }}>{s.num}</div>
              <div style={{ height: 1, background: 'rgba(255,255,255,0.06)', marginBottom: 20 }}>
                <div style={{ height: 1, background: i === 0 ? '#FF5E3A' : i === 1 ? '#34D399' : '#38BDF8', width: '40%', transition: 'width .6s' }} />
              </div>
              <h3 style={{ fontFamily: 'var(--heading)', fontWeight: 700, fontSize: 20, marginBottom: 10, letterSpacing: '-0.01em' }}>{s.title}</h3>
              <p style={{ color: '#71717A', fontSize: 14, lineHeight: 1.7 }}>{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:768px){.steps-grid{grid-template-columns:1fr !important;gap:40px !important}}`}</style>
    </section>
  );
}
